import { useEffect, useMemo, useRef, useState } from 'react'

import Ajv from 'ajv'
import { Control, useWatch } from 'react-hook-form'

import { Rules } from '../../utils/types'

const ajv = new Ajv()

interface Props {
  rules?: Rules
  control: Control
}

const useRules = (props: Props) => {
  const { rules = [], control } = props
  const [status, setStatus] = useState({
    isHide: false,
    isShow: true,
    isEnable: true,
    isDisable: false,
  })

  const validators = useRef([] as Array<any>)

  const dependantFields = useMemo(() => {
    let fields = [] as string[]
    rules.forEach((rule) => {
      fields = fields?.concat(rule?.watch || [])
    })

    const set = new Set(fields)
    const uniqueFields = Array.from(set)
    return uniqueFields
  }, [rules])

  const values = useWatch({ name: dependantFields, control })

  useEffect(() => {
    if (rules?.length) {
      validators.current = []
      rules.forEach((rule) => {
        const schema = rule.condition.schema
        const validator = ajv.compile(schema)
        validators.current?.push(validator)
      })
    }
  }, [rules])

  useEffect(() => {
    const _values = {}
    values?.forEach((val, i) => {
      _values[dependantFields[i]] = val
    })

    const isShow = validators.current?.[0]?.(_values) ?? true
    const _status = {
      isHide: !isShow,
      isShow: isShow,
      isEnable: false,
      isDisable: false,
    }
    setStatus(_status)
  }, [values])

  return status
}

export default useRules
